<pbc-sorter [config]="BereichsSorterConfig" [sorter]="bereichs.sorter$ | async" (sorterChange)="bereichs.sorter$.next($event)"></pbc-sorter>
